import { AfterViewInit, Directive, ElementRef, HostListener, Input, NgZone, OnChanges, Optional, SimpleChanges } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[appOverflowTooltip]'
})
export class OverflowTooltipDirective implements AfterViewInit, OnChanges {
  @Input('appOverflowTooltip') tooltipText = '';
  private cachedOverflow: boolean | null = null;

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private ngZone: NgZone,
    @Optional() private matTooltip?: MatTooltip,
  ) {}

  ngAfterViewInit(): void {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => this.updateTooltipState());
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.tooltipText) {
      this.cachedOverflow = null;
      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => this.updateTooltipState());
      });
    }
  }

  @HostListener('mouseenter')
  onMouseEnter(): void {
    this.ngZone.runOutsideAngular(() => {
      this.updateTooltipState();
    });
  }

  private updateTooltipState(): void {
    const element = this.elementRef.nativeElement;

    if (this.cachedOverflow === null) {
      this.cachedOverflow = element.scrollWidth > element.clientWidth || element.scrollHeight > element.clientHeight;
    }

    const hasOverflow = this.cachedOverflow;
    const message = (this.tooltipText || element.textContent || '').trim();

    if (this.matTooltip) {
      this.matTooltip.message = message;
      this.matTooltip.disabled = !hasOverflow || !message;
      return;
    }

    if (hasOverflow && message) {
      element.setAttribute('title', message);
      return;
    }

    element.removeAttribute('title');
  }
}
